<div class="app-report-control report-{{control.title.replace(' ', '-')}} d-flex flex-row-reverse align-items-start" [class.section-title]="control.isSectionTitle">
  <button mat-icon-button (click)="delete()"><mat-icon class="md-20">delete</mat-icon></button>
  <div class="content">
    <div class="report-control" [class.inline]="control.inline">
      @if (control.isProcedureField) {
        <app-procedure-field-renderer [control]="control"></app-procedure-field-renderer>
      }
      @if (control.isSingleLineTextField) {
        <app-single-line-text-field-renderer [control]="control"></app-single-line-text-field-renderer>
      }
      @if (control.isDatePicker) {
        <app-date-picker-renderer [control]="control"></app-date-picker-renderer>
      }
      @if (control.isMultiLineTextField) {
        <app-multi-line-text-field-renderer [control]="control"></app-multi-line-text-field-renderer>
      }
      @if (control.isJumpTextField) {
        <app-multi-line-text-field-renderer [control]="control"></app-multi-line-text-field-renderer>
      }
      @if (control.isLatestComment) {
        <app-comment-field-renderer [control]="control"></app-comment-field-renderer>
      }
      @if (control.isProblemList) {
        <app-problem-list-renderer [patientId]="patientId" [control]="control"></app-problem-list-renderer>
      }
      @if (control.isMedicationList) {
        <app-medication-list-renderer [patientId]="patientId" [control]="control"></app-medication-list-renderer>
      }
      @if (control.isTreatmentPlanList) {
        <app-treatment-plan-list-renderer [patientId]="patientId" [control]="control"></app-treatment-plan-list-renderer>
      }
      @if (control.isPatientSummary) {
        <app-patient-summary-renderer  [control]="control"></app-patient-summary-renderer>
      }
    </div>
    @if (control.isSectionTitle) {
      <app-section-title-renderer [control]="control"></app-section-title-renderer>
    }
  </div>
</div>
